( function(){
  'use strict';

  angular.module('eclipseApp.checkout').controller('storeLocatorModalCtrl', ['$scope', 'data', '$modalInstance', function($scope, data, $modalInstance){

    if (data && data.createUser && data.createUser.data && data.createUser.data.serviceAddress && data.createUser.data.serviceAddress.postalCode) {
      $scope.searchLocation = data.createUser.data.serviceAddress.postalCode;
    }
    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

  }]);
})();
